var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCooling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C12.55 2 13 2.45 13 3V6.17L14.59 4.58C14.98 4.2 15.61 4.2 16 4.58C16.39 4.97 16.39 5.6 16 6L13.71 8.29L16.83 9.29L18.41 7.71C18.8 7.32 19.43 7.32 19.83 7.71C20.22 8.1 20.22 8.73 19.83 9.12L18.24 10.71L21 12L18.24 13.29L19.83 14.88C20.22 15.27 20.22 15.9 19.83 16.29C19.43 16.68 18.8 16.68 18.41 16.29L16.83 14.71L13.71 15.71L16 18C16.39 18.39 16.39 19.02 16 19.41C15.61 19.8 14.98 19.8 14.59 19.41L13 17.83V21C13 21.55 12.55 22 12 22C11.45 22 11 21.55 11 21V17.83L9.41 19.41C9.02 19.8 8.39 19.8 8 19.41C7.61 19.02 7.61 18.39 8 18L10.29 15.71L7.17 14.71L5.59 16.29C5.2 16.68 4.57 16.68 4.17 16.29C3.78 15.9 3.78 15.27 4.17 14.88L5.76 13.29L3 12L5.76 10.71L4.17 9.12C3.78 8.73 3.78 8.1 4.17 7.71C4.57 7.32 5.2 7.32 5.59 7.71L7.17 9.29L10.29 8.29L8 6C7.61 5.6 7.61 4.97 8 4.58C8.39 4.2 9.02 4.2 9.41 4.58L11 6.17V3C11 2.45 11.45 2 12 2Z",
    fill: "#1F2D3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCooling);
export default __webpack_public_path__ + "static/media/cooling.896b4973fec3e4d433fdea3a4d9cfca7.svg";
export { ForwardRef as ReactComponent };